import { render } from "./ReputationCalculator.vue?vue&type=template&id=4dfd1d60&scoped=true"
import script from "./ReputationCalculator.vue?vue&type=script&lang=js"
export * from "./ReputationCalculator.vue?vue&type=script&lang=js"

import "./ReputationCalculator.vue?vue&type=style&index=0&id=4dfd1d60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dfd1d60"]])

export default __exports__